import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component

export default class Spinner extends Vue {

  @Prop()
  private hasContent!: boolean;

  @Prop()
  private delayAcceptance!: number;

  @Prop()
  private color?: string;

  @Prop()
  private position?: string;

  @Prop()
  private size?: number;

  @Prop()
  private text?: string;

  private loading: boolean = true;

  private showSpinner: boolean = false;

  private threshold: number | undefined = undefined;

  @Watch('hasContent', {immediate: true})
  private isLoading (next: boolean, prev: boolean) {

    if (next) {

      if ((typeof this.threshold) == 'number' && next) {

        clearTimeout(this.threshold);
      }

      this.loading = !next;
      this.showSpinner = !next;
      this.threshold = undefined;
      return;
    }
  
    return this.threshold = setTimeout(() => this.showSpinner = !this.showSpinner, this.delayAcceptance);
  }
}